module.exports = __webpack_public_path__ + "watkins_glen.be1a1f99679d228c8d514def99771a29.png";